import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { EncDecService } from 'src/app/modules/shared/services/encryption-decryption.service';
import { UtilsService } from 'src/app/modules/shared/services/utils.service';
import * as moment  from 'moment';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppointmentV2Service {

  seachTabChanged:BehaviorSubject<any> = new BehaviorSubject(0);
  constructor(private http: HttpClient,
    private util: UtilsService,
    // private encDecService: EncDecService
    ) {

  }

  getSessionCalanderByDistrict(payload:any):Observable<any>{
    let filter = ''
    if(this.util.isPresent(payload.vaccine)){
      filter += `&vaccine=${payload.vaccine}`;
    }
    return this.http.get<any>(`${environment.appointment_url_v4}/sessions/public/calendarByDistrict?district_id=${payload.district_id}&date=${payload.date}${filter}`);
  }

  getSessionCalanderByPincode(payload:any):Observable<any>{
    let filter = ''
    // if(this.util.isPresent(payload.vaccine)){
    //   filter += `&vaccine=${payload.vaccine}`;
    // }
    return this.http.get<any>(`${environment.appointment_url_v4}/sessions/public/calendarByPin?pincode=${payload.pincode}&date=${payload.date}`);
  }

  getV2StateList():Observable<any>{
    return this.http.get(`${environment.admin_prefix_url_v2}/location/states`)
  }

  getV2DistrictList(state_id:any):Observable<any>{
    return this.http.get(`${environment.admin_prefix_url_v2}/location/districts/${state_id}`)
  }

  getCentersByLatLong(payload:any):Observable<any>{
    return this.http.get(`${environment.appointment_url_v2}/centers/public/findByLatLong?lat=${payload.lat}&long=${payload.long}`);
  }

  getSlots(payload:any):Observable<any>{
    return this.http.get(`${environment.appointment_url_v2}/sessions/public/calendarByCenter?center_id=${payload.center_id}&date=${payload.from}`)
  }
}
